module.exports = __webpack_public_path__ + "components/flag/static/square/la-5386ebb55356f4aaaa44d40d204aef35.svg";